<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="title-box">
                <div class="tit">资料下载</div>
                <div class="desc">在这里，让我们帮您找到您要的东西。</div>
            </div>
            <div class="search-box">
                <form @submit.prevent="doSearch">
                    <div class="left input">
                        <input type="text" placeholder="请输入关键词搜索" v-model="key">
                        <div class="clear" v-if="key.length > 0" @click="key = ''"></div>
                    </div>
                    <div class="right btn" @click="doSearch" :class="[key.length > 0 ? '' : 'hidden']"><span>搜索</span></div>
                </form>
            </div>
			<div class="tags-box" v-if="tags.length > 0">
				<div class="item" :class="[tags_choose === '' ? 'active' : '']" @click="tagsChoose('')">
					<div class="tit">全部</div>
				</div>
				<div class="item" :class="[item === tags_choose ? 'active' : '']" v-for="(item,index) in tags" :key="index" @click="tagsChoose(item)">
					<div class="tit">{{item}}</div>
				</div>
			</div>
            <div class="list" v-if="list.length > 0">
                <div class="clear box">
                    <div class="left item" v-for="item in list">
                        <div class="left title">
                            <div class="middle">{{item.title}}</div>
                        </div>
                        <div class="right btn-box" @click="showDownload(item)">
                            <div class="left type" :class="[item.type == 1 ? 'word' : item.type == 2 ? 'pdf' : 'ppt']"></div>
                            <div class="left btn">下载</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="loading" v-if="show_loading">
                <loading></loading>
            </div>
            <div  v-if="list.length <= 0 && !show_loading" class="footer-2">抱歉！没有找到相关的下载资料</div>
        </div>
        <down-load :file="file_info" v-if="file_info.file_id" @hideDownload="hideDownload"></down-load>
    </main>
</template>

<script>
    import Crumbs from "../../../components/pc/Crumbs";
    import DownLoad from "../../../components/pc/DownLoad";
    import Loading from "../../../components/pc/Loading";
    export default {
        name: 'download',
        data() {
            return {
                adv:{},
                key:"",
                page:1,
                list:[],
                file_info:{},
                show_loading:true,
				tags:[],
				tags_choose:"",
            }
        },
        components:{
            Loading,
            Crumbs,DownLoad
        },
        computed:{
            crumbs() {
				return {title:"资料下载",min_title:"data download"}
            },
        },
        watch:{
            key(newVal,oldVal){
                if(!newVal && oldVal){
                    this.doSearch();
                }
            }
        },
        methods: {
			tagsChoose(item){
				this.tags_choose = item;
				this.getFile();
			},
            doSearch(){
                this.page = 1;
                this.list =[];
                this.getFile();
				this.getTags();
            },
            showDownload(item){
                this.file_info = item;
            },
            hideDownload(){
                this.file_info = {};
            },
            getFile(){
                this.show_loading = true;
                this.http.request({
                    api:"file/getFile",
                    data:{
                        limit:999,
                        key:this.key,
						tag:this.tags_choose,
                        page:this.page,
                    },
                    success:(res)=>{
                        this.show_loading = false;
                        this.list = res.list;
                        this.$nextTick(()=>{
                            this.util.showBottom(true);
                        })
                    }
                })
            },
            checkLogin(){
                if(!this.util.getAccessToken()){
                    this.util.showAuth({
                        show:true,
                        close_btn:true,
                    })
                }
            },
			getTags(){
				this.http.request({
					api:"file/tags",
					data:{
						key:this.key,
					},
					success:(res)=>{
						this.tags = res.tags;
					}
				})
			}
        },
        mounted() {
            this.query = this.$route.query;
            this.getFile();
			this.getTags();
            this.checkLogin();
        },
        destroyed() {
            this.util.showAuth({
                show:false,
            })
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{background: #f6f6f6 url("~@/assets/image/2021/17.png") no-repeat bottom center;background-size: 100% auto; padding-top: 20px;
        .title-box{padding:30px;background: #fff;width: 1140px;margin:0 auto;box-shadow:0 0 10px 2px rgba(0,0,0,.1);
            .tit{font-size: 16px;line-height: 16px;border-left: 4px solid #0176ce;padding-left: 10px;font-weight: bold;}
            .desc{font-size: 13px;margin-top: 10px;line-height: 23px;color:#565656;padding-left: 14px;white-space: pre-line}
        }
        .search-box{height:50px;overflow: hidden;width: 1200px;margin: 20px auto 0;
            .input{width: 1000px;padding: 0 20px;background: #fff;position: relative;
                input{width:100%; height:50px;line-height: 50px;background: none;border: none;font-size: 16px;color:#000;}
                .clear{display: block;position:absolute;top:0;right:0; width: 50px;height:50px;line-height: 50px;background: url("~@/assets/image/m10.png") no-repeat center center;background-size: 20px; cursor: pointer;}
            }
            .btn{width: 160px;height:50px;text-align: center;line-height: 50px;color:#fff;background: #3176c8;font-size: 18px;cursor: pointer;
                span{display: inline-block;padding-left: 30px;background: url("~@/assets/image/76.png") no-repeat left center;background-size: 20px;}
            }
            .btn.hidden{background: #999;}
        }
		.tags-box{width: 1200px;margin: 20px auto 0;display: flex;align-items: center;flex-wrap: wrap;
			.item{ padding: 15px 30px;display: flex;align-items: center;justify-content: center;cursor: pointer;
				.tit{position: relative;padding-bottom: 5px;}
				.tit::after{content: "";display: block;position: absolute;bottom:0;left:0;width: 0;height:3px; background: #3176c8;border-radius: 2px;}
			}
			.item.active{
				.tit{color:#3176c8;}
				.tit::after{width: 100%;transition: all .3s ease;}
			}
		}
        .list{overflow: hidden;width: 1200px;margin: 20px auto 0;padding-bottom: 50px;
            .box{
                .item{width: 370px;height:80px;padding: 10px; margin-right: 13px;margin-bottom: 13px;background: #fff;
                    .title{width: 230px;padding: 0 25px;border-right: 1px solid #f3f3f3;
                        .middle{height:80px;font-size: 14px;line-height: 22px;color:#565656;}
                    }
                    .btn-box{padding-top: 23px;cursor: pointer;
                        .type{width: 30px;height:34px;background-repeat: no-repeat;background-position: center center;background-size: contain;}
                        .type.word{background-image: url("~@/assets/image/25_1.png");}
                        .type.pdf{background-image: url("~@/assets/image/23.png");}
                        .type.ppt{background-image: url("~@/assets/image/24.png");}
                        .btn{font-size: 14px;color:#3176c8;padding-left: 15px;background: url("~@/assets/image/25.png") no-repeat left center;background-size: 11px;margin-left: 8px;height:34px;line-height: 34px;}
                    }
                }
                .item:nth-child(3n){margin-right: 0;}
            }
        }
        .loading{height:500px;text-align: center;line-height: 500px;font-size: 14px;color:#999;}
    }
    .footer-2{height:300px;text-align: center;line-height: 200px;font-size: 14px;color:#999;}
</style>

